import IPForm from "components/IP/form"
import React from "react"
import { useSelector, useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"
import { storeIP } from "store/ips/ips-action"

const AddIP = () => {
  // Meta Title
  document.title = "Add IP"
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const { loading, error, data } = useSelector(state => state.ips)

  /*
  - handleSubmit: Triggered when the form is submitted
  - values: Contains the form input values
  - Dispatches the action to store the IP with the provided values
*/
  const handleSubmit = values => {
    dispatch(storeIP(values, navigate))
  }

  return (
    <IPForm
      onSubmit={handleSubmit}
      loading={loading}
      error={error}
      formMode={"Add"}
    />
  )
}

export default AddIP
